// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DELETED_REASON = "D\u00f4vod";
export const POST_IS_DELETED_FIND_WHY__IN_CODEX = ", pros\u00edm, \u010do je u n\u00e1s v poriadku a \u010do nie.";
export const POST_IS_DELETED_FIND_WHY__READ = "Pre\u010d\u00edtaj si";
export const VISIBILITY_ALERT_OR_LOGIN = "alebo sa prihl\u00e1s";
export const VISIBILITY_ALERT_REGISTER = "Zaregistruj sa";
